export default __webpack_public_path__ + "static/media/family_disc.51ae8304.png";